<div class="bg-white">
  <div class="card" style="border-bottom: none">
    <div class="card-header bg-info flex"
         style="height: 50px; align-items: center">
      <div class="grid-x text-left">
        <div class="cell shrink">
          <div class="card-title card-padding c-white flex"
               id="toggle-linear"
               style="align-items: center">
            <h2>{{'advertising.dialog.list.title' | translate}}</h2>
          </div>
        </div>
        <div class="cell shrink">
          <div class="grid-x text-left">
            <div class="cell shrink">
              <button (click)="closeDialog()" class="close-button" type="button">
                <span aria-hidden="true" class="c-white">&times;</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!showSpinner" class="card" style="border:0 none; box-shadow:none;">
      <div class="card-body">
        <div class="row expanded">
          <div class="columns small-12">
            <h5><p>{{'advertising.dialog.list.explanation' | translate}}</p></h5>
          </div>
          <div class="columns small-12">
            <table [dataSource]="dataSource" mat-table matSort>
              <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
              <tr *matRowDef="let advertising; columns: displayedColumns;" [class]="advertising.actif && !isExpired(advertising.endDate)?'':'inactive-advertising'"
                  mat-row></tr>
              <ng-container matColumnDef="actif">
                <th *matHeaderCellDef mat-header-cell
                    mat-sort-header> {{'advertising.dialog.list.table.actif' | translate}}</th>
                <td *matCellDef="let advertising" mat-cell><span
                  [class]="advertising.actif?'far fa-check ':'fas fa-close'"></span></td>
              </ng-container>
              <ng-container matColumnDef="title">
                <th *matHeaderCellDef mat-header-cell
                    mat-sort-header> {{'advertising.dialog.list.table.title' | translate}}</th>
                <td *matCellDef="let advertising" mat-cell>
                  <div (click)="modify(advertising)" class="cursor-hover">{{advertising.title}}</div>
                </td>
              </ng-container>
              <ng-container matColumnDef="startDate">
                <th *matHeaderCellDef mat-header-cell
                    mat-sort-header> {{'advertising.dialog.list.table.start-date' | translate}}</th>
                <td *matCellDef="let advertising" mat-cell>  {{advertising.startDate | date: 'dd/MM/yyyy'}} </td>
              </ng-container>
              <ng-container matColumnDef="endDate">
                <th *matHeaderCellDef mat-header-cell
                    mat-sort-header> {{'advertising.dialog.list.table.end-date' | translate}}</th>
                <td *matCellDef="let advertising" [style]="isExpired(advertising.endDate)?'background-color:grey':''"
                    mat-cell>
                  {{advertising.endDate | date: 'dd/MM/yyyy'}}
                  <span *ngIf="isExpired(advertising.endDate)" class="fas fa-exclamation" title="Expired"></span>
                </td>
              </ng-container>
              <ng-container matColumnDef="creationDate">
                <th *matHeaderCellDef mat-header-cell
                    mat-sort-header> {{'advertising.dialog.list.table.creation-date' | translate}}</th>
                <td *matCellDef="let advertising" mat-cell>
                  {{advertising.creationDate | date: 'dd/MM/yyyy hh:mm'}}
                </td>
              </ng-container>
              <ng-container matColumnDef="viewedQuantity">
                <th *matHeaderCellDef mat-header-cell
                    mat-sort-header> <span class="fal fa-eye" [title]="'advertising.dialog.list.table.viewed-quantity' | translate"></span></th>
                <td *matCellDef="let advertising" mat-cell [title]="'advertising.dialog.list.viewed-quantity' | translate:{quantity:advertising.viewedQuantity}">
                  {{advertising.viewedQuantity}}
                </td>
              </ng-container>
              <ng-container matColumnDef="modify">
                <th *matHeaderCellDef mat-header-cell></th>
                <td *matCellDef="let advertising" mat-cell>
                  <button (click)="modify(advertising)" [title]="'advertising.dialog.list.modify' | translate" class="margin-t-s"
                          mat-button>
                    <span class="fal fa-pencil"></span>
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="duplicate">
                <th *matHeaderCellDef mat-header-cell></th>
                <td *matCellDef="let advertising" mat-cell>
                  <button (click)="duplicate(advertising)" [title]="'advertising.dialog.list.duplicate' | translate" class="margin-t-s"
                          mat-button>
                    <span class="fal fa-copy"></span>
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="preview">
                <th *matHeaderCellDef mat-header-cell></th>
                <td *matCellDef="let advertising" mat-cell>
                  <button (click)="preview(advertising)" [title]="'advertising.dialog.list.preview' | translate" class="margin-t-s"
                          mat-button>
                    <span class="fal fa-external-link"></span>
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="delete">
                <th *matHeaderCellDef mat-header-cell></th>
                <td *matCellDef="let advertising" mat-cell>
                  <button (click)="delete(advertising)" [title]="'advertising.dialog.list.delete' | translate " class="margin-t-s"
                          mat-button>
                    <span class="fal fa-trash"></span>
                  </button>
                </td>
              </ng-container>
            </table>
          </div>
        </div>
      </div>
      <div class="card-footer border-reset text-right ">
        <button (click)="create()" class="margin-t-s" mat-button>
          {{'advertising.dialog.list.create' | translate }}
        </button>
      </div>
    </div>
    <div *ngIf="showSpinner" class="widget-spinner padding-v-l">
      <div></div>
    </div>
  </div>
</div>
